import { render, staticRenderFns } from "./planclist.vue?vue&type=template&id=12a5bb61&scoped=true&"
import script from "./planclist.vue?vue&type=script&lang=js&"
export * from "./planclist.vue?vue&type=script&lang=js&"
import style0 from "./planclist.vue?vue&type=style&index=0&id=12a5bb61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a5bb61",
  null
  
)

export default component.exports